import { KeyValue } from '@angular/common';

export enum DomiciliationType {
  ApprovedAssociation = 'ApprovedAssociation',
  CCAS = 'CCAS',
  CHRS = 'CHRS',
  MDM = 'MDM',
}

export enum DomiciliationTypeLabel {
  ApprovedAssociation = 'Association agrée',
  CCAS = 'CCAS',
  CHRS = 'CHRS',
  MDM = 'MDM',
}

export const labelsByDomiciliationType: KeyValue<DomiciliationType, string>[] = Object.keys(DomiciliationType).map((x: DomiciliationType) => {
  return { key: x, value: DomiciliationTypeLabel[x] };
});
